import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=b193ec06&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style0 from "./Editor.vue?vue&type=style&index=0&id=b193ec06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b193ec06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b193ec06')) {
      api.createRecord('b193ec06', component.options)
    } else {
      api.reload('b193ec06', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=b193ec06&scoped=true", function () {
      api.rerender('b193ec06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Editor.vue"
export default component.exports